import {
  DEFAULT_REPORT_PERIOD,
  SHARMA_REPORT_PATHS,
} from "../config/sharmaReportsConfig";
import {
  PARENT_PORTFOLIO_API_IDS,
  PARENT_PORTFOLIO_KEYS,
} from "../config/portfolioConfig";
import { fetchSharmaReportJson } from "./sharmaReportsApi";

export async function fetchPortfolioAllocation(opts = {}) {
  const {
    portfolioApiId = PARENT_PORTFOLIO_API_IDS[PARENT_PORTFOLIO_KEYS.MAIN],
    period = DEFAULT_REPORT_PERIOD,
    signal,
    retries,
  } = opts;
  return fetchSharmaReportJson(SHARMA_REPORT_PATHS.portfolioAllocation, {
    portfolioApiId,
    period,
    signal,
    retries,
  });
}
